/**
 * Warehouse PDP: Description | Vehicle Fitment tabs + "Does this fit my car?" checker.
 * Matching uses only rows parsed from product.metafields.halo.customtab HTML tables.
 */
(function () {
  'use strict';

  function textOf(el) {
    return (el.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function parseYearRange(yearCell) {
    var s = String(yearCell || '');
    var m = s.match(/(\d{4})\s*[-–]\s*(?:(\d{4})|(ON|On|PRESENT|Present|CURRENT|Current))?/);
    if (m) {
      var start = parseInt(m[1], 10);
      var end = m[2] ? parseInt(m[2], 10) : (m[3] ? 9999 : start);
      return { start: start, end: end, label: s };
    }
    var single = s.match(/\b(\d{4})\b/);
    if (single) {
      var y = parseInt(single[1], 10);
      return { start: y, end: y, label: s };
    }
    return null;
  }

  function parseFitmentTable(root) {
    var rows = [];
    if (!root) return rows;
    var trs = root.querySelectorAll('table tr');
    trs.forEach(function (tr) {
      var cells = tr.querySelectorAll('td, th');
      if (cells.length < 3) return;
      var make = textOf(cells[0]);
      var model = textOf(cells[1]);
      var yearCell = textOf(cells[2]);
      if (!make || !model) return;
      // skip header-ish rows
      if (/^make$/i.test(make) && /^model$/i.test(model)) return;
      var range = parseYearRange(yearCell);
      rows.push({
        make: make,
        model: model,
        yearLabel: yearCell,
        start: range ? range.start : null,
        end: range ? range.end : null,
        h: tr.getAttribute('data-h') || '',              // vehicle collection handle (hk-fitment-source only)
        excluded: tr.getAttribute('data-fit-excluded') || '' // exclusion text when this vehicle is NOT suitable
      });
    });
    return rows;
  }

  function uniqueSorted(values) {
    var seen = {};
    var out = [];
    values.forEach(function (v) {
      var key = v.toUpperCase();
      if (!seen[key]) {
        seen[key] = true;
        out.push(v);
      }
    });
    out.sort(function (a, b) {
      return a.localeCompare(b, undefined, { sensitivity: 'base' });
    });
    return out;
  }

  function fillSelect(select, values, placeholder) {
    select.innerHTML = '';
    var opt0 = document.createElement('option');
    opt0.value = '';
    opt0.textContent = placeholder;
    select.appendChild(opt0);
    values.forEach(function (v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      select.appendChild(opt);
    });
  }

  function norm(s) {
    return String(s || '').replace(/\s+/g, ' ').trim().toUpperCase();
  }

  function initTabs(root) {
    var nav = root.querySelectorAll('[data-product-tab]');
    var panels = root.querySelectorAll('[data-product-panel]');
    if (!nav.length) return;

    function activate(id) {
      nav.forEach(function (btn) {
        var on = btn.getAttribute('data-product-tab') === id;
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.classList.toggle('is-active', on);
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-product-panel') === id;
        panel.hidden = !on;
        panel.classList.toggle('is-active', on);
      });
    }

    nav.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-product-tab'));
      });
      // WAI-ARIA tabs keyboard pattern: Left/Right (wrap), Home/End move focus and select
      btn.addEventListener('keydown', function (e) {
        var n = nav.length, j = null;
        if (e.key === 'ArrowRight') j = (i + 1) % n;
        else if (e.key === 'ArrowLeft') j = (i - 1 + n) % n;
        else if (e.key === 'Home') j = 0;
        else if (e.key === 'End') j = n - 1;
        if (j === null) return;
        e.preventDefault();
        activate(nav[j].getAttribute('data-product-tab'));
        nav[j].focus();
      });
    });

    root._activateProductTab = activate;
  }

  function openFitmentTab() {
    var tabs = document.querySelector('[data-product-tabs]');
    if (tabs && typeof tabs._activateProductTab === 'function') {
      tabs._activateProductTab('fitment');
      tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    var fitBtn = document.querySelector('[data-product-tab="fitment"]');
    if (fitBtn) {
      fitBtn.click();
      fitBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function initChecker(root) {
    var source = root.querySelector('[data-fitment-source]');
    var rows = parseFitmentTable(source);
    if (!rows.length) {
      root.hidden = true;
      return;
    }

    var makeSel = root.querySelector('[data-fit-make]');
    var modelSel = root.querySelector('[data-fit-model]');
    var yearSel = root.querySelector('[data-fit-year]');
    var checkBtn = root.querySelector('[data-fit-check]');
    var result = root.querySelector('[data-fit-result]');
    var openTab = root.querySelector('[data-fit-open-tab]');

    /* Change vehicle (20 Oct 2026, staging): on the fitment panel (data-fit-saved) the make/model/year pickers list the FULL
       vehicle finder (assets/vehicle-data.json via data-vehicle-data), merged with this product's own rows, instead of only
       the product's rows. Check fit saves the choice to vf:vehicle (same shape as assets/vehicle-filter.js) and reports
       whether THIS product fits it. Other checkers keep the product-only list. */
    var pick = rows.slice();
    function fillMakes() { fillSelect(makeSel, uniqueSorted(pick.map(function (r) { return r.make; })), 'Select make'); }
    var vdUrl = root.getAttribute('data-vehicle-data');
    if (root.hasAttribute('data-fit-saved') && vdUrl && window.fetch) {
      fetch(vdUrl, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (d) {
        var pre = d.url_prefix || '/collections/';
        (d.makes || []).forEach(function (mk) { (mk.m || []).forEach(function (md) { (md.v || []).forEach(function (v) {
          var dup = pick.some(function (r) { return (r.h && r.h === v.h) || (norm(r.make) === norm(mk.n) && norm(r.model) === norm(md.n) && norm(r.yearLabel) === norm(v.l)); });
          if (!dup) pick.push({ make: mk.n, model: md.n, yearLabel: v.l, h: v.h, u: v.u || (pre + v.h), finderOnly: true });
          else pick.forEach(function (r) { if (r.h === v.h) r.u = v.u || (pre + v.h); });
        }); }); });
        var keep = makeSel.value; fillMakes(); if (keep) makeSel.value = keep;
      }).catch(function () {});
    }
    fillMakes();
    fillSelect(modelSel, [], 'Select model');
    fillSelect(yearSel, [], 'Select year / chassis');
    modelSel.disabled = true;
    yearSel.disabled = true;

    function modelsForMake(make) {
      return uniqueSorted(
        pick.filter(function (r) { return norm(r.make) === norm(make); }).map(function (r) { return r.model; })
      );
    }

    function yearsForMakeModel(make, model) {
      return uniqueSorted(
        pick
          .filter(function (r) {
            return norm(r.make) === norm(make) && norm(r.model) === norm(model);
          })
          .map(function (r) { return r.yearLabel; })
      );
    }

    var resBase = (result.className || '').split(/\s+/)[0] || 'product-fit-checker__result';
    function clearResult() {
      result.hidden = true;
      result.textContent = '';
      result.className = resBase;
    }

    makeSel.addEventListener('change', function () {
      var make = makeSel.value;
      clearResult();
      fillSelect(yearSel, [], 'Select year / chassis');
      yearSel.disabled = true;
      if (!make) {
        fillSelect(modelSel, [], 'Select model');
        modelSel.disabled = true;
        return;
      }
      fillSelect(modelSel, modelsForMake(make), 'Select model');
      modelSel.disabled = false;
    });

    modelSel.addEventListener('change', function () {
      var make = makeSel.value;
      var model = modelSel.value;
      clearResult();
      if (!make || !model) {
        fillSelect(yearSel, [], 'Select year / chassis');
        yearSel.disabled = true;
        return;
      }
      fillSelect(yearSel, yearsForMakeModel(make, model), 'Select year / chassis');
      yearSel.disabled = false;
    });

    yearSel.addEventListener('change', clearResult);

    if (openTab) {
      openTab.addEventListener('click', function (e) {
        e.preventDefault();
        openFitmentTab();
      });
    }

    function setResult(kind, html) {
      result.hidden = false;
      result.className = resBase + ' ' + resBase + '--' + kind;
      result.innerHTML = html;
    }

    /* ---- custom.fitment_notes products (data-fit-saved): saved vehicle + exclusions (Reade, 11 Oct 2026) ----
       Verdicts: excluded (red)  = vehicle is an exclusion's excluded_vehicle collection
                 caution (amber) = vehicle is on the list, but some exclusions have no vehicle collection yet (e.g. Rogue, GR Sport)
                 yes (green)     = on the list, no unresolved exclusions
                 no              = not on the list (saved vehicle only) */
    var fx = root.hasAttribute('data-fit-saved');
    var rich = root.hasAttribute('data-fit-rich');
    var excl = [];
    try { excl = JSON.parse(root.getAttribute('data-fit-exclusions') || '[]') || []; } catch (e) { excl = []; }
    var unresolved = excl.filter(function (x) { return !x.h; }).map(function (x) { return x.t; });
    var savedBox = root.querySelector('[data-fit-saved-box]');
    var savedName = root.querySelector('[data-fit-saved-name]');
    var form = root.querySelector('[data-fit-form]');
    var changeBtn = root.querySelector('[data-fit-change]');
    var ICONS = {
      yes: '<path d="m5 12 5 5 9-10"/>',
      caution: '<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>',
      excluded: '<circle cx="12" cy="12" r="9"/><path d="m5.7 5.7 12.6 12.6"/>',
      no: '<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/>',
      ambiguous: '<circle cx="12" cy="12" r="9"/><path d="M12 8v5M12 16h.01"/>'
    };
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function joinOr(list, word) { return list.length < 2 ? (list[0] || '') : list.slice(0, -1).join(', ') + ' ' + word + ' ' + list[list.length - 1]; }
    function say(kind, head, body) {
      if (rich) {
        setResult(kind, '<span class="fx-res__i" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">' + ICONS[kind] + '</svg></span><div><strong>' + head + '</strong><span>' + body + '</span></div>');
      } else {
        setResult(kind, '<strong>' + head + '</strong> ' + body);
      }
    }
    function verdict(row, handle, model) {
      var hit = null;
      if (handle) excl.forEach(function (x) { if (x.h && x.h === handle) hit = x; });
      if (hit || (row && row.excluded)) {
        say('excluded', 'Not suitable for your vehicle.', 'This product is not suitable for ' + esc(hit ? hit.t : row.excluded) + '.');
        return 'excluded';
      }
      if (!row) {
        say('no', 'Not listed for your vehicle: we cannot guarantee fitment.', 'Your vehicle is not on this product\u2019s Vehicle Fitment list.');
        return 'no';
      }
      if (unresolved.length) {
        say('caution', 'Fits your ' + esc(model || row.model) + ', except ' + esc(joinOr(unresolved, 'and')) + '.',
          'Please check your vehicle isn\u2019t one of these models before you order.');
        return 'caution';
      }
      say('yes', 'Yes, this fits your vehicle.', 'Matches: ' + esc(row.yearLabel) + '. Please read the fitment notes before you order.');
      return 'yes';
    }
    function readSaved() {
      try { var v = JSON.parse(localStorage.getItem('vf:vehicle') || 'null'); return v && v.h ? v : null; } catch (e) { return null; }
    }
    function showForm() {
      if (savedBox) savedBox.hidden = true;
      if (form) form.hidden = false;
      clearResult();
    }
    // data-fit-vf (17 Oct 2026): the Vehicle fitment card above has its own status banner (initFitStatus), so this card is only the picker:
    // always show the make/model/year form and give a verdict only when the shopper presses Check fit.
    var vfMode = root.hasAttribute('data-fit-vf');
    function applySaved() {
      var v = readSaved();
      if (vfMode) { if (savedBox) savedBox.hidden = true; if (form) form.hidden = false; return; }
      if (!v || !savedBox) { showForm(); return; }
      var row = null;
      rows.forEach(function (r) { if (r.h && r.h === v.h && (!row || r.excluded)) row = r; });
      savedName.textContent = v.n || [v.mk, v.md, v.l].join(' ');
      savedBox.hidden = false;
      if (form) form.hidden = true;
      verdict(row, v.h, v.md);
    }
    if (fx) {
      root._fitOpenForm = function () { showForm(); if (makeSel) makeSel.focus({ preventScroll: true }); };
      if (changeBtn) changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        showForm();
        if (makeSel) makeSel.focus();
      });
      document.addEventListener('vehicle-filter:change', applySaved);
      window.addEventListener('storage', function (e) { if (e.key === 'vf:vehicle') applySaved(); });
      applySaved();
    }


    function runCheck() {
      var make = makeSel.value;
      var model = modelSel.value;
      var yearLabel = yearSel.value;

      if (!make || !model || !yearLabel) {
        if (fx) { say('ambiguous', 'Select make, model and year / chassis to check fitment.', 'If your vehicle is not in the list, we cannot guarantee fitment.'); return; }
        setResult('ambiguous', 'Select make, model, and year / chassis to check fitment. If your vehicle is not in the list, we cannot guarantee fitment.');
        return;
      }

      var matched = rows.filter(function (r) {
        return (
          norm(r.make) === norm(make) &&
          norm(r.model) === norm(model) &&
          norm(r.yearLabel) === norm(yearLabel)
        );
      });

      if (fx) {
        // chosen vehicle may come from the full finder: resolve its collection handle, then test THIS product's rows by handle
        var chosen = pick.filter(function (r) { return norm(r.make) === norm(make) && norm(r.model) === norm(model) && norm(r.yearLabel) === norm(yearLabel); })[0] || null;
        var ch = chosen ? chosen.h : '';
        var own = null;
        rows.forEach(function (r) { if (((ch && r.h === ch) || (!ch && matched.indexOf(r) > -1)) && (!own || r.excluded)) own = r; });
        var kind = verdict(own, ch, model);
        if (ch) {
          var sv = { h: ch, u: (chosen && chosen.u) || ('/collections/' + ch), n: make + ' ' + model + ' ' + yearLabel, mk: make, md: model, l: yearLabel };
          try { localStorage.setItem('vf:vehicle', JSON.stringify(sv)); } catch (e2) {}
          document.dispatchEvent(new CustomEvent('vehicle-filter:change', { detail: { vehicle: sv } }));
        }
        if (ch) { document.dispatchEvent(new CustomEvent('hk-fit:checked', { detail: { h: ch, mk: make, md: model, l: yearLabel, n: make + ' ' + model + ' ' + yearLabel, kind: kind } })); return; }
        // the buy-box compact row (initCompact) follows the vehicle last checked here
        if (matched[0]) document.dispatchEvent(new CustomEvent('hk-fit:checked', { detail: { h: matched[0].h, mk: make, md: model, l: yearLabel, n: make + ' ' + model + ' ' + yearLabel, kind: kind } }));
        return;
      }

      if (matched.length) {
        setResult(
          'yes',
          '<strong>Yes — this fits.</strong> Matches: ' + yearLabel + '.'
        );
        return;
      }

      // Should be rare with cascading selects; still handle gracefully
      setResult(
        'no',
        '<strong>Not listed for this vehicle — we cannot guarantee fitment.</strong> That combination is not in this product’s Vehicle Fitment list.'
      );
    }

    checkBtn.addEventListener('click', function (e) {
      e.preventDefault();
      runCheck();
    });
  }

  /* Compact buy-box fit row (snippets/product-info.liquid, custom.fitment_notes products; Reade approved 11 Oct 2026).
     Shows the saved vehicle (vf:vehicle), or the vehicle last checked in the Vehicle Fitment tab, with a status pill;
     no vehicle -> "Check fit for your vehicle". Links are #tab-fitment (handled below); Change / Check fit also open the tab
     checker's selects. Status rules match the tab checker: excluded > not listed > caution (unlinked exclusions) > fits. */
  var FIT_LABEL = { yes: 'Fits', caution: 'Fits \u2013 check exclusions', excluded: 'Not suitable', no: 'Not listed' };
  function fitKind(rows, excl, handle) {
    var row = null, hit = null;
    rows.forEach(function (r) { if (r.h && r.h === handle && (!row || r.excluded)) row = r; });
    excl.forEach(function (x) { if (x.h && x.h === handle) hit = x; });
    if (hit || (row && row.excluded)) return 'excluded';
    if (!row) return 'no';
    if (excl.some(function (x) { return !x.h; })) return 'caution';
    return 'yes';
  }
  function initCompact(root) {
    var rows = parseFitmentTable(root.querySelector('[data-fitment-source]'));
    var excl = [];
    try { excl = JSON.parse(root.getAttribute('data-fit-exclusions') || '[]') || []; } catch (e) { excl = []; }
    var cta = root.querySelector('[data-fitbox-check]'), row = root.querySelector('[data-fitbox-row]');
    var nameEl = root.querySelector('[data-fitbox-name]'), pill = root.querySelector('[data-fitbox-pill]');
    function readSaved() {
      try { var v = JSON.parse(localStorage.getItem('vf:vehicle') || 'null'); return v && v.h ? v : null; } catch (e) { return null; }
    }
    function render(v) {
      if (!v || !v.h) { row.hidden = true; cta.hidden = false; return; }
      var kind = v.kind || fitKind(rows, excl, v.h);
      var years = String(v.l || '').split(' ')[0];
      nameEl.textContent = [v.mk, v.md, years].filter(Boolean).join(' ') || v.n || '';
      nameEl.title = v.n || nameEl.textContent;
      pill.className = 'fitbox__pill fitbox__pill--' + kind;
      pill.textContent = FIT_LABEL[kind] || '';
      row.classList.toggle('fitbox__row--no', kind === 'no'); // red card for Not listed (staging, 13 Oct 2026)
      cta.hidden = true; row.hidden = false;
    }
    render(readSaved());
    document.addEventListener('vehicle-filter:change', function () { render(readSaved()); });
    window.addEventListener('storage', function (e) { if (e.key === 'vf:vehicle') render(readSaved()); });
    document.addEventListener('hk-fit:checked', function (e) { render(e.detail); });
  }

  /* Fit-status banner at the top of the Vehicle fitment card (snippets/hk-vehicle-fitment.liquid, data-hkvf-status; Reade approved 17 Oct 2026).
     Reads the SAME fitKind() result as the buy-box pill (initCompact): saved vehicle (vf:vehicle) or the vehicle last checked in the tab,
     its collection handle against the product's [data-fitment-source] rows (data-h) + exclusions.
     States: yes (Fits your X [+ position when it is one]), caution (Fits, check exclusions), excluded (Not suitable), no (Doesn't fit), none (Choose your vehicle).
     If the product has no vehicle-collection rows at all (no data-h source), the card's own rows (make / model / years) are matched instead. */
  function initFitStatus(el) {
    var card = el.closest('[data-hkvf]');
    if (!card) return;
    var scope = card.closest('.hk-fx') || document;
    var chk = scope.querySelector('[data-fit-checker]');
    var compact = document.querySelector('[data-fit-compact]');
    var srcEl = (chk && chk.querySelector('[data-fitment-source]')) || (compact && compact.querySelector('[data-fitment-source]'));
    var rows = parseFitmentTable(srcEl);
    var excl = [];
    try { excl = JSON.parse(((chk || compact) && (chk || compact).getAttribute('data-fit-exclusions')) || '[]') || []; } catch (e) { excl = []; }
    var trs = [].slice.call(card.querySelectorAll('tbody tr')).map(function (tr) {
      return { mk: tr.getAttribute('data-mk') || '', md: tr.getAttribute('data-md') || '', yr: tr.getAttribute('data-yr') || '', pos: tr.getAttribute('data-pos') || '' };
    });
    var ICO = {
      yes: '<path d="m5 12 5 5 9-10"/>',
      caution: '<path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/><path d="M12 9v4M12 17h.01"/>',
      excluded: '<circle cx="12" cy="12" r="9"/><path d="m5.7 5.7 12.6 12.6"/>',
      no: '<path d="M6 6l12 12M18 6 6 18"/>',
      none: '<path d="M5 17H3.5a.5.5 0 0 1-.5-.5V13l2-5.2A2 2 0 0 1 6.9 6.5h10.2a2 2 0 0 1 1.9 1.3L21 13v3.5a.5.5 0 0 1-.5.5H19"/><path d="M3 13h18M9 17h6"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/>'
    };
    function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    function readSaved() {
      try { var v = JSON.parse(localStorage.getItem('vf:vehicle') || 'null'); return v && v.h ? v : null; } catch (e) { return null; }
    }
    function sq(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); }
    function same(a, b) { a = sq(a); b = sq(b); return !!a && !!b && (a === b || a.indexOf(b) > -1 || b.indexOf(a) > -1); }
    function span(s) {
      var m = String(s || '').match(/\b(?:19|20)\d{2}\b/g) || [];
      if (!m.length) return null;
      var a = +m[0], b = m[1] ? +m[1] : (/\bon\b|present|current/i.test(s) ? 9999 : a);
      return [a, b];
    }
    function matchRows(v) {
      var vy = span(v.l);
      return trs.filter(function (r) {
        if (!same(r.mk, v.mk) || !same(r.md, v.md)) return false;
        var ry = span(r.yr);
        return !vy || !ry || (vy[0] <= ry[1] && ry[0] <= vy[1]);
      });
    }
    function kindFor(v) {
      if (v.kind) return v.kind;
      if (rows.length) return fitKind(rows, excl, v.h);
      // no vehicle-collection rows on this product: match the card's own list
      if (excl.some(function (x) { return x.h && x.h === v.h; })) return 'excluded';
      if (!matchRows(v).length) return 'no';
      return excl.some(function (x) { return !x.h; }) ? 'caution' : 'yes';
    }
    function posFor(v) {
      var set = [];
      matchRows(v).forEach(function (r) { if (r.pos && set.indexOf(r.pos) < 0) set.push(r.pos); });
      if (!set.length) trs.forEach(function (r) { if (r.pos && set.indexOf(r.pos) < 0) set.push(r.pos); });
      return set.length === 1 ? set[0].replace(' And ', ' & ') : '';
    }
    function exclText(v) {
      var t = '';
      excl.forEach(function (x) { if (x.h && x.h === v.h) t = x.t; });
      if (!t) rows.forEach(function (r) { if (r.h && r.h === v.h && r.excluded) t = r.excluded; });
      return t;
    }
    function paint(v) {
      // the in-tab picker (Does this fit my car?) only exists when the product has vehicle-collection rows; without it there is nothing for the button to open
      var hasPicker = !!(chk && !chk.hidden && typeof chk._fitOpenForm === 'function');
      var kind = v ? kindFor(v) : 'none', name = '', head = '', sub = '', btn = 'Change vehicle';
      if (v) name = esc([v.mk, v.md, String(v.l || '').split(' ')[0]].filter(Boolean).join(' ') || v.n || 'vehicle');
      if (kind === 'none') {
        head = 'Choose your vehicle to check fitment'; btn = 'Choose vehicle';
        sub = hasPicker ? 'We\u2019ll tell you if this fits and where it goes.' : 'Pick your vehicle in the vehicle finder and we\u2019ll tell you if this fits and where it goes.';
      } else if (kind === 'yes') {
        var p = posFor(v);
        head = 'Fits your ' + name; sub = (p ? 'Fitted at the ' + esc(p.toLowerCase()) + '. ' : '') + 'It\u2019s on this product\u2019s fitment list.';
      } else if (kind === 'caution') {
        var un = excl.filter(function (x) { return !x.h; }).map(function (x) { return x.t; });
        head = 'Fits your ' + name + ' \u2013 check exclusions';
        sub = un.length ? 'Not suitable for ' + esc(un.join('; ')) + '. Check your vehicle isn\u2019t one of these before you order.' : 'Check this product\u2019s exclusions before you order.';
      } else if (kind === 'excluded') {
        var et = exclText(v);
        head = 'Not suitable for your ' + name; sub = et ? 'This product is not suitable for ' + esc(et) + '.' : 'This vehicle is on this product\u2019s exclusion list.';
      } else {
        head = 'Doesn\u2019t fit your ' + name; sub = 'It\u2019s not in this product\u2019s fitment list, so we can\u2019t guarantee fitment.';
      }
      el.className = 'hkvf__st hkvf__st--' + kind;
      el.innerHTML = '<span class="hkvf__sti"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + ICO[kind] + '</svg></span>' +
        '<div class="hkvf__stt"><strong>' + head + '</strong><span>' + sub + '</span></div>' +
        (hasPicker ? '<button type="button" class="hkvf__stb" data-hkvf-change>' + btn + '</button>' : '');
    }
    el.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('[data-hkvf-change]')) return;
      e.preventDefault();
      if (chk && !chk.hidden && typeof chk._fitOpenForm === 'function') {
        chk._fitOpenForm();
        chk.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
    paint(readSaved());
    document.addEventListener('vehicle-filter:change', function () { paint(readSaved()); });
    window.addEventListener('storage', function (e) { if (e.key === 'vf:vehicle') paint(readSaved()); });
    document.addEventListener('hk-fit:checked', function (e) { paint(e.detail); });
  }

  /* Tab links (Northman staging, Reade approved 11 Oct 2026; used by the HILUX-020RPRO description prompt cards).
     Any link to #tab-<key> (description | kit | warranty | fitment) switches to that tab and scrolls to the tab strip,
     same mechanism as "View full Vehicle Fitment" (root._activateProductTab). Also honours a #tab-<key> hash on page load.
     If the product has no such tab (e.g. no kit), the click is simply ignored.
     Listens in the capture phase and stops propagation, because Warehouse's delegate on body handles every [href^="#"]
     click with document.querySelector(hash).offsetParent and throws when no element has that id. */
  function tabFromHash(hash) {
    var m = /^#tab-(description|overview|kit|warranty|fitment)$/.exec(hash || '');
    return m ? (m[1] === 'overview' ? 'description' : m[1]) : null; // the Overview tab keeps the key 'description'
  }
  function goToTab(key, focus) {
    var root = document.querySelector('[data-product-tabs]');
    var btn = root && root.querySelector('[data-product-tab="' + key + '"]');
    if (!btn || typeof root._activateProductTab !== 'function') return false;
    root._activateProductTab(key);
    var header = document.querySelector('.header, .shopify-section--header, #shopify-section-header');
    var offset = (header ? header.getBoundingClientRect().height : 0) + 16;
    window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - offset, behavior: 'smooth' });
    if (focus) btn.focus({ preventScroll: true });
    return true;
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#tab-"]');
    if (!a) return;
    var key = tabFromHash(a.getAttribute('href'));
    if (!key) return;
    e.preventDefault();
    e.stopPropagation(); // Warehouse's own [href^="#"] smooth-scroll delegate (theme.js) would throw: there's no element with that id
    if (goToTab(key, true) && history.replaceState) history.replaceState(null, '', '#tab-' + key);
    if (a.hasAttribute('data-fitbox-change') || a.hasAttribute('data-fitbox-check')) {
      var tabChecker = document.querySelector('[data-product-panel="fitment"] [data-fit-checker]');
      if (tabChecker && typeof tabChecker._fitOpenForm === 'function') tabChecker._fitOpenForm();
    }
  }, true); // capture phase, so this runs before the theme's body-level delegate
  function openTabFromHash() { var k = tabFromHash(location.hash); if (k) goToTab(k, false); }

  function boot() {
    document.querySelectorAll('[data-product-tabs]').forEach(initTabs);
    document.querySelectorAll('[data-fit-checker]').forEach(initChecker);
    document.querySelectorAll('[data-fit-compact]').forEach(initCompact);
    document.querySelectorAll('[data-hkvf-status]').forEach(initFitStatus);
    // #tab-<key> in the URL opens that tab (after layout settles so the scroll lands in the right place)
    if (tabFromHash(location.hash)) {
      if (document.readyState === 'complete') openTabFromHash();
      else window.addEventListener('load', openTabFromHash);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
